export default __webpack_public_path__ + "static/media/responses.dfe2ad91.svg";